import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, useMemo } from 'react';
import classnames from 'classnames';
import { StyledSwitchBase, Icon, CheckedIcon } from './Checkbox.styles';
var Checkbox = forwardRef(function (props, ref) {
  var disabled = props.disabled,
      otherProps = __rest(props, ["disabled"]);

  var _a = useMemo(function () {
    var iconClassname = classnames({
      disabled: disabled
    });
    return {
      icon: _jsx(Icon, {
        className: iconClassname
      }),
      checkedIcon: _jsx(CheckedIcon, {
        className: iconClassname
      })
    };
  }, [disabled]),
      icon = _a.icon,
      checkedIcon = _a.checkedIcon;

  return _jsx(StyledSwitchBase, __assign({
    type: "checkbox",
    icon: icon,
    checkedIcon: checkedIcon,
    ref: ref,
    disabled: disabled
  }, otherProps));
});
export default memo(Checkbox);